import type { FaireProductEntity } from "../../entity_types/product";

export const p_5vgrbuy29n: FaireProductEntity = {
  token: "p_5vgrbuy29n",
  type: "product",
  name: "Mini Drops® Bath Bombs - Soothing",
  brandToken: "b_2vgr3yu7bj",
  brandName: "Dabble & Dollop®",
  imageUrl:
    "https://cdn.faire.com/fastly/fbd29ca743c405465f1eb2a6c63b48be43f9d934b1bdd2abd844205ac3d61496.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00da9630d29fb1d13e20ddbdc36a73350822d2ae7b93cc5720faf5543a4b3ade.jpeg",
    "https://cdn.faire.com/fastly/e851e2b9d35f181a3816f47553906c741c9a7a2764f08cc458b052b1ebaeafe4.jpeg",
    "https://cdn.faire.com/fastly/6f3719e948585a62673e17fadecbe3d20de23bd03000ba21a26888982d70afb4.jpeg",
    "https://cdn.faire.com/fastly/0c54ee23e8a600da5782a171585a0ef0302cd6fde221bb7de6571dfd258c4647.png",
  ],
  priceDollars: 8.99,
  description:
    "NEW, MORE COLORFUL PACKAGING\n\nSet of 12\n\nDabble & Dollop Mini Drops take bath bombs to the next level. Clean, free of artificial colors and dyes, it's the safe way to make bath time fun and encourage creativity. Set includes 12 bath bombs in four soothing scents: 3 Lavender, 3 Chamomile, 3 Vanilla, and 3 Rose.  Each Droplet is “kid-sized” at 1 inch, making them perfect for a gentle, moisturizing, sweetly scented bath experience. \n\nOur hand-selected, natural-origin ingredients are vegan, gluten-free, cruelty-free, and made in the USA, using both domestic and globally sourced ingredients. Our new packaging is more colorful, features larger print, and is easier to identify when sold alongside our other amazing bath bomb scents!\n\nPlease note each Droplet is individually wrapped in a thin, recyclable plastic casing necessary to protect the integrity of the bath bomb during shipping and to preserve the natural scents at home. ",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:31.583Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
